/*
 * @Author: zhangguoliang
 * @Date: 2022-11-16 13:52:42
 * @LastEditors: zhangguoliang
 * @LastEditTime: 2022-12-21 11:01:29
 */
import "./public-path";
import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";
import { createPinia } from "pinia";
import {
  Button,
  Layout,
  Dropdown,
  Menu,
  Divider,
  Form,
  Input,
  Spin,
  Popover,
  Checkbox,
  Table,
  Modal,
  Pagination,
  Image,
  Card,
  ConfigProvider
} from "ant-design-vue";
import "./permission.ts";
import microApp from "@micro-zoe/micro-app";

const app = createApp(App);

app
  .use(Button)
  .use(Layout)
  .use(Dropdown)
  .use(Menu)
  .use(Divider)
  .use(Form)
  .use(Input)
  .use(Spin)
  .use(Checkbox)
  .use(Popover)
  .use(Table)
  .use(Modal)
  .use(Pagination)
  .use(Image)
  .use(Card)
  .use(ConfigProvider)

app.use(createPinia()).use(router).mount("#app");

microApp.start();
